import { MessageContext } from "src/context/MessageContext";
import { useContext } from "react";

const useMessage = () => useContext(MessageContext);

export default useMessage;
